import React, { useState, useEffect } from 'react';
import './TextZoomSlider.css';

const STORAGE_KEY = 'vedictools_text_zoom';

const TextZoomSlider = () => {
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? parseInt(saved, 10) : 100;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, zoom.toString());
    document.documentElement.style.setProperty('--text-zoom', `${zoom / 100}`);
  }, [zoom]);

  const handleZoomChange = (e) => {
    setZoom(parseInt(e.target.value, 10));
  };

  const resetZoom = () => {
    setZoom(100);
  };

  return (
    <div className="text-zoom-slider">
      <span className="zoom-icon zoom-icon-small">अ</span>
      <input
        type="range"
        min="80"
        max="150"
        step="10"
        value={zoom}
        onChange={handleZoomChange}
        className="zoom-range"
        title={`Text size: ${zoom}%`}
      />
      <span className="zoom-icon zoom-icon-large">अ</span>
      <button
        className="zoom-reset"
        onClick={resetZoom}
        title="Reset to 100%"
        disabled={zoom === 100}
      >
        {zoom}%
      </button>
    </div>
  );
};

export default TextZoomSlider;
